import React, { useEffect, useRef, useState } from "react";
// import { useWindowSize } from "../../hooks/useWindowSize";
import Icon from "../Icon";
import spinner from "../../assets/spinnerloader.svg";
import InfoIcon from "../../assets/icons/info.svg";

import {
  PlayerWrapper,
  OptimizationBanner,
  TooltipWrapper,
  TooltipText,
  // DeviceWarning
} from "./styles";

type VideoPlayerProps = {
  videoUrl: string;
  isCompressed?: boolean;
  blockDownload?: boolean;
  isOwner?: boolean;
  canBeCompressed?: boolean;
  optimizationRate?: number;
};

const CustomVideoPlayer: React.FC<VideoPlayerProps> = ({
  videoUrl,
  blockDownload = true,
  isOwner,
  optimizationRate,
  canBeCompressed,
  isCompressed,
}) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  // const { isMobile } = useWindowSize();
  const [isVertical, setIsVertical] = useState(false);
  // const [isUnsupportedDevice, setIsUnsupportedDevice] = useState(false);

  // Detectar orientación vertical
  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const handleMetadata = () => {
      const { videoWidth, videoHeight } = video;
      setIsVertical(videoHeight > videoWidth);
    };

    video.addEventListener("loadedmetadata", handleMetadata);
    return () => {
      video.removeEventListener("loadedmetadata", handleMetadata);
    };
  }, [videoUrl]);

  // Detectar dispositivos problemáticos
  useEffect(() => {
    const ua = navigator.userAgent.toLowerCase();
    // const isMotoG20 = /moto\s?g\(?20\)?/.test(ua);
    // const androidVersionMatch = ua.match(/android\s([0-9]+)/);
    // const androidVersion = androidVersionMatch ? parseInt(androidVersionMatch[1], 10) : null;
    // const isOldAndroid = androidVersion !== null && androidVersion <= 11;

  //   if (isMotoG20 && isOldAndroid) {
  //     setIsUnsupportedDevice(true);
  //   }
  }, []);

  // Activar volumen al hacer play
  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const handlePlay = () => {
      if (video.muted) {
        video.muted = false;
      }
      video.removeEventListener("play", handlePlay);
    };

    video.addEventListener("play", handlePlay);
    return () => {
      video.removeEventListener("play", handlePlay);
    };
  }, []);

  return (
    <PlayerWrapper isVertical={isVertical}>
      {/* {isUnsupportedDevice && (
        <DeviceWarning>
          ⚠️ Tu dispositivo no soporta bien este video.
          <a href={videoUrl} download>Descargar video</a>
        </DeviceWarning>
      )} */}

      {isOwner && !!canBeCompressed && (
        <OptimizationBanner>
          {!isCompressed ? (
            <>
              💡 Klouser está optimizando este video{" "}
              <Icon icon={spinner} size="12px" color="white" />
            </>
          ) : (
            `🚀 El peso del video fue optimizado${optimizationRate ? ` un ${optimizationRate}%` : ""}`
          )}
          <TooltipWrapper>
            <Icon icon={InfoIcon} size="14px" color="white" style={{ cursor: "pointer" }} />
            <TooltipText>
              {!isCompressed
                ? "Estamos comprimiendo este video para reducir su peso sin perder calidad. Mientras tanto se puede consumir el video original. Solo tú ves este mensaje."
                : "Klouser optimizó este video para mejorar la experiencia de tus suscriptores. Solo tú ves este mensaje."}
            </TooltipText>
          </TooltipWrapper>
        </OptimizationBanner>
      )}

      <video
        ref={videoRef}
        playsInline
        controls
        muted
        preload="metadata"
        onContextMenu={(e) => e.preventDefault()}
        controlsList={blockDownload && !isOwner ? "nodownload" : undefined}
      >
        <source src={videoUrl} type="video/mp4" />
        ⚠️ Tu dispositivo no soporta bien este video.
        <a href={videoUrl} download>Descargar video</a>
      </video>
    </PlayerWrapper>
  );
};

export default React.memo(CustomVideoPlayer);
